import { RootState } from 'store/rootSlices';

export const getAppSlice = (state: RootState) => state.App;
export const getLogsSudentSlice = (state: RootState) => state.LogsStudent;
